import type { MatchesCalendarState } from './slices';
import { reducer } from './slices';
import type { MatchesCalendarOptions } from './types';

import { getOptionsProvider } from '@shared/OptionsProvider';
import { zustandStoreFactory } from '@shared/zustandStoreFactory';

export const {
  Provider: MatchesCalendarFeedProvider,
  useStore: useMatchesCalendarStore,
  createStore: createMatchesCalendarStore,
} = zustandStoreFactory<MatchesCalendarState>(reducer, 'MatchesCalendar');

export const { OptionsProvider: MatchesCalendarOptionsProvider, useOptions: useMatchesCalendarOptions } =
  getOptionsProvider<MatchesCalendarOptions>();
